import { render, staticRenderFns } from "./GradeDashboard.vue?vue&type=template&id=1d338b79&scoped=true&"
import script from "./GradeDashboard.vue?vue&type=script&lang=js&"
export * from "./GradeDashboard.vue?vue&type=script&lang=js&"
import style0 from "./GradeDashboard.vue?vue&type=style&index=0&id=1d338b79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d338b79",
  null
  
)

export default component.exports